import { render, staticRenderFns } from "./createCoupons.vue?vue&type=template&id=c04dcde0&scoped=true&"
import script from "./createCoupons.vue?vue&type=script&lang=js&"
export * from "./createCoupons.vue?vue&type=script&lang=js&"
import style0 from "./createCoupons.vue?vue&type=style&index=0&id=c04dcde0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04dcde0",
  null
  
)

export default component.exports